/**
 * Strikte lazy-loading voor below-fold afbeeldingen.
 *
 * Native loading="lazy" gebruikt op trage verbindingen een threshold van
 * 1250px+ waardoor below-fold afbeeldingen alsnog tijdens de page load
 * binnenkomen en (in Lighthouse's simulatie) met de LCP-afbeelding om
 * bandbreedte concurreren. Afbeeldingen met [data-deferred] houden hun
 * src/srcset in data-attributen tot ze binnen 300px van de viewport komen.
 */
(() => {
  const load = (img) => {
    if (img.dataset.srcset) img.setAttribute('srcset', img.dataset.srcset);
    if (img.dataset.src) img.setAttribute('src', img.dataset.src);
    img.removeAttribute('data-deferred');
  };

  const supported = 'IntersectionObserver' in window;
  const io = supported
    ? new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              load(entry.target);
              io.unobserve(entry.target);
            }
          }
        },
        { rootMargin: '300px 0px' }
      )
    : null;

  const scan = (root) => {
    const imgs = (root instanceof Element ? root : document).querySelectorAll('img[data-deferred]');
    imgs.forEach((img) => (io ? io.observe(img) : load(img)));
  };

  const init = () => {
    scan(document);
    // Secties kunnen na load opnieuw gerenderd/gemorpht worden (section
    // renderer, theme editor); nieuw toegevoegde deferred imgs meepakken.
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node instanceof Element) scan(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', () => scan(document));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
